// Vertical Mode Floating Menu
(function() {
  // Only run in vertical mode
  function isVerticalMode() {
    return document.documentElement.classList.contains('display-vertical');
  }

  if (!isVerticalMode()) {
    return;
  }

  console.log('[VerticalMenu] Initializing vertical menu dock');

  const menu = document.getElementById('vertical-floating-menu');
  if (!menu) {
    console.log('[VerticalMenu] Menu element not found');
    return;
  }

  const catalogButton = menu.querySelector('[data-vertical-menu-catalog]');
  const cartButton = menu.querySelector('[data-vertical-menu-cart]');
  const searchButton = menu.querySelector('[data-nt-open="search"]');
  const clearCartButton = menu.querySelector('[data-vertical-menu-clear-cart]');
  const backButton = menu.querySelector('[data-vertical-menu-back]');

  // Open catalog (trigger mobile menu) - Toggle functionality 
  function openCatalog(e) {
    e.preventDefault();
    
    // Check if catalog is already open
    const catalogDrawer = document.querySelector('.ntm.is-open');
    
    if (catalogDrawer) {
      // Catalog is open, close it
      const closeBtn = catalogDrawer.querySelector('[data-ntm-close]');
      if (closeBtn) {
        closeBtn.click();
      } else {
        catalogDrawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      return;
    }
    
    // Catalog is closed, proceed to open it
    // Close search drawer if it's open
    const searchDrawer = document.getElementById('SearchDrawer');
    if (searchDrawer && searchDrawer.hasAttribute('open')) {
      if (typeof searchDrawer.hide === 'function') {
        searchDrawer.hide();
      } else {
        searchDrawer.removeAttribute('open');
      }
    }
    
    // Close cart drawer if it's open
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && cartDrawer.hasAttribute('open')) {
      if (typeof cartDrawer.hide === 'function') {
        cartDrawer.hide();
      } else {
        cartDrawer.removeAttribute('open');
      }
      // Wait a bit for the drawer to close before opening catalog
      setTimeout(() => {
        openCatalogMenu();
      }, 300);
    } else {
      openCatalogMenu();
    }
  }

  // Helper function to open the catalog menu
  function openCatalogMenu() {
    const mobileMenuBtn = document.querySelector('.ntm__hamb');
    if (mobileMenuBtn) {
      mobileMenuBtn.click();
    } else {
      console.warn('[VerticalMenu] Mobile menu button not found');
    }
  }

  // Clear cart
  async function clearCart(e) {
    e.preventDefault();
    
    if (!confirm('¿Estás seguro de que quieres vaciar el carrito?')) {
      return;
    }

    console.log('[VerticalMenu] Clearing cart');
    
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        console.log('[VerticalMenu] Cart cleared successfully');
        // Reload the page to reflect changes
        window.location.reload();
      } else {
        throw new Error('Failed to clear cart');
      }
    } catch (error) {
      console.error('[VerticalMenu] Error clearing cart:', error);
      alert('Hubo un error al vaciar el carrito. Por favor, inténtalo de nuevo.');
    }
  }

  // Go back
  function goBack(e) {
    e.preventDefault();
    console.log('[VerticalMenu] Going back');
    window.history.back();
  }

  // Open cart drawer
  function openCartDrawer(e) {
    e.preventDefault();
    
    // Close search drawer if it's open
    const searchDrawer = document.getElementById('SearchDrawer');
    if (searchDrawer && searchDrawer.hasAttribute('open')) {
      if (typeof searchDrawer.hide === 'function') {
        searchDrawer.hide();
      } else {
        searchDrawer.removeAttribute('open');
      }
    }
    
    // Close catalog menu if it's open
    const catalogDrawer = document.querySelector('.ntm.is-open');
    if (catalogDrawer) {
      const closeBtn = catalogDrawer.querySelector('[data-ntm-close]');
      if (closeBtn) {
        closeBtn.click();
      } else {
        catalogDrawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      // Wait for the catalog drawer to close before opening cart
      setTimeout(() => {
        openCartDrawerHelper();
      }, 300);
    } else {
      openCartDrawerHelper();
    }
  }

  // Helper function to open the cart drawer
  function openCartDrawerHelper() {
    const cartDrawerButton = document.querySelector('[aria-controls="CartDrawer"]');
    if (cartDrawerButton) {
      cartDrawerButton.click();
    } else {
      console.warn('[VerticalMenu] Cart drawer button not found');
      window.location.href = '/cart';
    }
  }

  // Open search drawer
  function openSearchDrawer(e) {
    e.preventDefault();
    
    // Close catalog menu if it's open
    const catalogDrawer = document.querySelector('.ntm.is-open');
    if (catalogDrawer) {
      const closeBtn = catalogDrawer.querySelector('[data-ntm-close]');
      if (closeBtn) {
        closeBtn.click();
      } else {
        catalogDrawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
    }
    
    // Close cart drawer if it's open
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && cartDrawer.hasAttribute('open')) {
      if (typeof cartDrawer.hide === 'function') {
        cartDrawer.hide();
      } else {
        cartDrawer.removeAttribute('open');
      }
    }
    
    // Try multiple selectors for the search drawer button
    const searchSelectors = [
      '[aria-controls="SearchDrawer"]',
      '.search-drawer-button',
      '[data-drawer-toggle="search"]',
      '[data-open-search]'
    ];
    
    let searchButton = null;
    for (const selector of searchSelectors) {
      searchButton = document.querySelector(selector);
      if (searchButton) break;
    }
    
    if (searchButton) {
      searchButton.click();
    } else {
      console.warn('[VerticalMenu] Search drawer button not found');
      window.location.href = '/search';
    }
  }
 
  // Dock menu is always visible, no collapsed state needed

  // Event listeners

  if (catalogButton) {
    catalogButton.addEventListener('click', openCatalog);
  }

  if (cartButton) {
    cartButton.addEventListener('click', openCartDrawer);
  }

  if (searchButton) {
    searchButton.addEventListener('click', openSearchDrawer);
  }

  if (clearCartButton) {
    clearCartButton.addEventListener('click', clearCart);
  }

  if (backButton) {
    backButton.addEventListener('click', goBack);
  }

  console.log('[VerticalMenu] Vertical menu dock initialized successfully');
})();
